<template>
  <!-- 弹窗框 -->
  <el-dialog :title="dialogTitle" append-to-body :visible.sync="dialog.modal" width="420px"
    :close-on-click-modal="false" @close="cancel" class='handleDialogS'>
    <div class="form-item-public" v-loading="dialog.loading" :element-loading-text="loadingText">
      <span class="warining" v-show="ifEdits">科目已被使用,不能够进行修改!</span>
      <el-form label-width="90px" ref="formData" :model="formData" :rules="dialogRules">
        <el-form-item label="上级科目:" prop="fk_superSubject" :required="subParent">
          <!-- @visible-change="getAllSubjectByTree($event, () => { })" -->
          <el-select :disabled="disEdit || disFK" size="mini" v-model="formData.fk_superSubject" filterable clearable
            @change="disableChage($event, true)">
            <el-option v-for="(item, index) in listLabel.parentObject" :key="index" :label="item.code + ' ' + item.name"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item required label="科目编码:" prop="selfCode">
          <span v-show="disCode">{{ formData.code + '' + formData.selfCode }}</span>
          <el-input v-show="!disCode" :disabled="disCode" size="mini" v-model.number="formData.selfCode"
            placeholder="请输入科目编码" clearable>
            <template slot="prepend" v-if="formData.code != '' && formData.code != null">{{ formData.code }}</template>
          </el-input>
        </el-form-item>
        <el-form-item label="科目名称:" prop="subname">
          <el-input size="mini" :disabled="ifSubName" v-model="formData.subname" placeholder="请输入科目名称"
            clearable></el-input>
        </el-form-item>
        <el-form-item label="科目类别:" prop="type">
          <el-select :disabled="disedit || disEdit" size="mini" v-model="formData.type" clearable>
            <el-option v-for="(item, index) in listLabel.typelist" :key="index" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="余额方向:" prop="creditDirection">
          <el-radio-group v-model="formData.creditDirection">
            <el-radio label="借" :disabled="disedit || disEdit"></el-radio>
            <el-radio label="贷" :disabled="disedit || disEdit"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="收入属性 :" prop="attribute" v-if="ifmbf">
          <el-radio-group v-model="formData.attribute">
            <el-radio label="unqualified">非限定性</el-radio>
            <el-radio label="qualified">限定性</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="辅助核算:" prop="auxiliary">
          <el-checkbox v-model="formData.auxiliary" :disabled="ifNewAdd1 || ifEdit || haveData || !hasChild"
            @change="chagesCheck($event, 'auxiliaryStrs')" label="辅助核算" name="type"></el-checkbox>
        </el-form-item>
        <el-form-item label="辅助类别:" prop="auxiliaryStrs" v-if="formData.auxiliary">
          <el-checkbox-group v-model="formData.auxiliaryStrs" @change="groupsChange($event, 'auxiliary')">
            <el-checkbox :disabled="ifNewAdd1 || ifEdit || haveData || !hasChild"
              v-for="(item, index) in listLabel.fztypes" :label="item.name" :key="index">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="数量核算:" prop="numberAccounting">
          <el-checkbox v-model="formData.numberAccounting" :disabled="ifNewAdd2 || ifEdit || haveData || !hasChild"
            @change="chagesCheck($event, 'unit')" label="数量核算" name="type"></el-checkbox>
        </el-form-item>
        <el-form-item label="计量单位:" prop="unit" v-if="formData.numberAccounting">
          <el-input size="mini" :disabled="ifNewAdd2 || ifEdit || haveData || !hasChild" v-model="formData.unit"
            placeholder="请输入计量单位"></el-input>
        </el-form-item>
        <el-form-item label="外币核算:" prop="foreignCurrency">
          <el-checkbox :disabled="ifNewAdd3 || ifEdit || haveData || !hasChild" v-model="formData.foreignCurrency"
            @change="chagesCheck($event, 'foreignCurrencyStr')" label="外币核算" name="type"></el-checkbox>
        </el-form-item>
        <el-form-item label="外币类别:" prop="foreignCurrencyStr" v-if="formData.foreignCurrency">
          <el-checkbox-group v-model="formData.foreignCurrencyStr" @change="groupsChange($event, 'foreignCurrency')">
            <el-checkbox :disabled="ifNewAdd3 || ifEdit || haveData || !hasChild"
              v-for="(item, index) in listLabel.wbtypes" :label="item.name" :key="index">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="记账:">
          <el-checkbox label="现金日记账" v-model="formData.cashJournal" :disabled="ifCashJournal"></el-checkbox>
          <el-checkbox label="银行日记账" v-model="formData.bankJournal" :disabled="ifBankJournal"></el-checkbox>
        </el-form-item>
        <el-form-item label="期末调汇:">
          <el-checkbox v-model="formData.remittance"></el-checkbox>
        </el-form-item>
        <el-form-item label="" v-if='formData.cashFlowStatementShow'>
          <el-checkbox v-model="mustTrue" label='可分配到现金流量表' :disabled='mustTrue'></el-checkbox>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer-right" v-show="!dialog.loading">
      <el-button size="small" @click="cancel">取消</el-button>
      <el-button size="small" class='minButton' @click="submitVoucher">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ["show", "subjectData", "subParent"],
  data() {
    const number = (rule, value, callback) => {
      if (isNaN(value)) {
        callback(new Error("科目编号只能是数字!"));
      } else {
        callback();
      }
    };
    const subject = (rule, value, callback) => {
      if (this.subParent && (value == "" || value == null)) {
        callback(new Error("请选择上级科目!"));
      } else {
        callback();
      }
    };
    return {
      mustTrue: true, // 现金流量表一直选中
      loadingText: "加载中",
      dialog: {
        edit: "add",
        modal: false,
        loading: false,
      },
      formData: {
        cashFlowStatementShow: false, // 是否显示现金流量表分配
        fk_superSubject: "",
        code: "",
        selfCode: "",
        selfCodeStr: "",
        subname: "",
        type: "",
        creditDirection: "借",
        foreignCurrency: false,
        numberAccounting: false,
        remittance: false,
        cashJournal: false,
        bankJournal: false,
        auxiliary: false,
        auxiliaryStrs: [],
        unit: "",
        foreignCurrencyStr: [],

        attribute: "", // 2019-12-10 新增 民办非
      },
      dialogRules: {
        fk_superSubject: [{ validator: subject }],
        selfCode: [
          { required: true, message: "科目编码必填!" },
          { validator: number },
        ],
        subname: [{ required: true, message: "科目名称必填!" }],
        type: [{ required: true, message: "科目类别必选!" }],
      },
      listLabel: {
        parentObject: [],
        typelist: [],
        fztypes: [],
        wbtypes: [],
      },
      disedit: false,
      disedit1: false,
      ifEdits: false,
      disFK: false, //是否可以修改科目编码
      ifSubName: false, //是否可以修改科目名称
      ifEdit: false,
      ifNewAdd1: false, /// 辅助核算
      ifNewAdd2: false, //	数量核算
      ifNewAdd3: false, //	外币核算
      ifCashJournal: false, // 是否可以修改现金日记账
      ifBankJournal: false, //是否可以修改银行日记账
      hasChild: false, //是否有下级
      haveData: false, //是否已被使用
      hasChild1: false, //是否有下级
      haveData1: false, //是否已被使用

      ifmbf: false, //是否是名半非
    };
  },
  computed: {
    dialogTitle: {
      get() {
        var str = "新增科目";
        if (this.subjectData.methods == "add") {
          str = "新增科目";
        } else if (this.subjectData.methods == "edit") {
          str = "修改科目";
        } else if (this.subjectData.methods == "newAdd") {
          str = "新增下一级科目";
        }
        return str;
      },
    },
    disEdit: {
      //修改
      get() {
        if (
          this.subjectData.methods == "edit" ||
          this.subjectData.methods == "new"
        ) {
          return true;
        } else {
          return false;
        }
      },
    },
    disCode: {
      get() {
        if (this.disedit1) {
          return false;
        } else {
          if (this.disedit || this.disEdit) {
            return true;
          } else {
            return false;
          }
        }
      },
    },
    editTit: {
      get() {
        if (this.subjectData.methods == "add") {
          return "新增科目";
        } else if (this.subjectData.methods == "newAdd") {
          return "新增下级科目";
        } else if (this.subjectData.methods == "edit") {
          return "修改科目";
        }
      },
    },
  },
  methods: {
    //查询是否是否为民间非盈利
    checkIfPrivateNonProfit() {
      const _ = this;
      _.loading = true;
      _.loadingText = "查询中...";
      _.$http
        .post("createAccountSet/isPrivateNonProfit", {})
        .then((res) => {
          _.loading = false;
          if (res && res.data.code == "1") {
            _.ifmbf = res.data.data;
            _.formData.attribute = "unqualified";
          }
        })
        .catch((e) => {
          _.loading = false;
        });
    },
    //获取上级科目
    getAllSubjectByTree(callback) {
      const _ = this;
      _.dialog.loading = true;
      _.loadingText = "查询上级科目中";
      let datas = {
        //type:_.formData.type,
      };
      _.$http
        .post("subject/findAll", datas)
        .then((res) => {
          _.dialog.loading = false;
          if (res && res.data.code == "1") {
            _.listLabel.parentObject = res.data.data;
            callback();
          }
        })
        .catch((e) => {
          _.dialog.loading = false;
        });
    }, //获取科目类别
    getAllSubjectType() {
      const _ = this;
      _.loading = true;
      _.loadingText = "查询科目类别";
      let datas = {};
      _.$http
        .post("subject/getSubjectType", datas)
        .then((res) => {
          if (res && res.data.code == "1") {
            _.listLabel.typelist = res.data.data;
            _.formDatas.type = res.data.data[0];
          }
        })
        .catch((e) => {
          _.loading = false;
        });
    },
    //查询辅助类别
    findAllOject() {
      const _ = this;
      _.dialog.loading = true;
      _.loadingText = "查询辅助类别中";
      let datas = {};
      _.$http
        .post("auxiliaryAccounting/allAccounting", datas)
        .then((res) => {
          _.dialog.loading = false;
          if (res && res.data.code == "1") {
            _.listLabel.fztypes = res.data.data;
          }
        })
        .catch((e) => {
          _.dialog.loading = false;
        });
    }, //查询外币
    findAllCurrency() {
      const _ = this;
      _.dialog.loading = true;
      _.loadingText = "查询外币中";
      let datas = {};
      _.$http
        .post("foreignCurrency/findAll", datas)
        .then((res) => {
          _.dialog.loading = false;
          if (res && res.data.code == "1") {
            _.listLabel.wbtypes = res.data.data;
          }
        })
        .catch((e) => {
          _.dialog.loading = false;
        });
    },
    disableChage(val, bol, callback) {
      const _ = this;
      if (val != "" && val != null) {
        this.disedit = true;
        _.dialog.loading = true;
        _.loadingText = "查询科目中";
        _.$http
          .post("subject/getCode", {
            id: val,
          })
          .then((res) => {
            _.dialog.loading = false;
            if (res && res.data.code == "1") {
              var code = "";
              _.listLabel.parentObject.find((item) => {
                if (item.id == val) {
                  _.formData.type = item.type;
                  //console.log('有子科目：'+item.hasChild,'被使用'+item.initialValue);
                  if (_.subjectData.methods != "edit") {
                    _.disedit1 = true;
                    _.formData.code = item.code;
                    _.hasChild = item.hasChild;
                    _.hasChild1 = item.hasChild;
                    if (item.initialValue == null) {
                      _.haveData = false;
                      _.haveData1 = false;
                    } else {
                      _.haveData = !item.initialValue;
                      _.haveData1 = !item.initialValue;
                    }
                    _.formData.creditDirection = item.creditDirection;
                    if (_.hasChild && !_.haveData) {
                      //当每有被使用并且 新增的第二个以后的科目  清空值
                      _.formData = Object.assign(_.formData, {
                        subname: "",
                        foreignCurrency: false,
                        numberAccounting: false,
                        cashJournal: false,
                        bankJournal: false,
                        auxiliary: false,
                        auxiliaryStrs: [],
                        foreignCurrencyStr: [],
                        unit: "",
                      });
                    }
                  } else {
                    _.disedit1 = false;
                  }
                }
              });
              if (_.subjectData.methods != "edit") {
                _.formData.selfCode = res.data.msg ? res.data.msg : "";
                _.formData.selfCodeStr = res.data.msg ? res.data.msg : "";
              } else {
                //console.log(2,_.subjectData)
                _.formData.selfCode = _.subjectData.code
                  ? _.subjectData.code
                  : "";
                _.formData.selfCodeStr = _.subjectData.selfCode
                  ? _.subjectData.selfCode
                  : "";
              }
            }
            callback();
          })
          .catch((e) => {
            _.dialog.loading = false;
          });
      } else {
        this.disedit = false;
        _.formData.code = "";
        _.formData.selfCode = "";
        _.hasChild = true;
        _.haveData = false;
        _.ifNewAdd1 = false;
        _.ifNewAdd2 = false;
        _.ifNewAdd3 = false;
        _.formData = Object.assign(_.formData, {
          subname: "",
          foreignCurrency: false,
          numberAccounting: false,
          cashJournal: false,
          bankJournal: false,
          auxiliary: false,
          auxiliaryStrs: [],
          foreignCurrencyStr: [],
          unit: "",
          cashFlowStatementShow: false,
        });
        _.ifCashJournal = false;
        _.ifBankJournal = false;
      }
      if (_.subjectData.methods != "edit") {
        //当选择的下级有辅助核算 数量核算 和外币核算时 不能自行更改
        let items = _.listLabel.parentObject.find((item) => {
          if (item.id == val) {
            return item;
          }
        });
        // 新增下一级 如果 辅助核算  数量核算  外币核算 选择  就不能进行修改
        items.auxiliary ? (_.ifNewAdd1 = true) : (_.ifNewAdd1 = false);
        items.numberAccounting ? (_.ifNewAdd2 = true) : (_.ifNewAdd2 = false);
        items.foreignCurrency ? (_.ifNewAdd3 = true) : (_.ifNewAdd3 = false);
        ///辅助核算  如果辅助核算有值 则有辅助核算并赋值
        if (items.auxiliary && items.auxiliary.length > 0) {
          _.formData.auxiliary = true;
          _.formData.auxiliaryStrs = items.auxiliary;
        } else {
          _.formData.auxiliary = false;
          _.formData.auxiliaryStrs = [];
        }
        ///辅助核算  如果辅助核算有值 则有辅助核算并赋值
        _.formData.numberAccounting = items.numberAccounting;
        _.formData.unit = items.unit;
        _.formData.foreignCurrency = items.foreignCurrency;
        _.formData.foreignCurrencyStr = items.foreignCurrencys;

        _.formData.cashJournal = items.cashJournal;
        _.formData.bankJournal = items.bankJournal;

        if (val != "" && val != null) {
          //如果包含 银行 现金
          let names = _.listLabel.parentObject.find((item) => {
            if (item.id == val) {
              return item;
            } else {
              return "";
            }
          });
          this.formData.cashFlowStatementShow = names.cashFlowButton; // 是否显示现金流量表分配
          if (names.name.indexOf("现金") != -1) {
            this.ifBankJournal = true;
            this.formData.cashJournal = true;
          } else if (names.name.indexOf("银行") != -1) {
            this.ifCashJournal = true;
            this.formData.bankJournal = true;
          } else {
            this.ifCashJournal = false;
            this.ifBankJournal = false;
          }
        }
      }
    }, //新增科目
    submitVoucher() {
      const _ = this;
      if (_.ifEdits) {
        _.$message.error("已被使用，无法修改！");
        return false;
      }
      _.$refs.formData.validate((valid) => {
        if (valid) {
          let datas = JSON.parse(JSON.stringify(_.formData));
          //辅助核算
          if (datas.auxiliary && datas.auxiliaryStrs <= 0) {
            _.$message.error("请选择辅助类别！");
            return false;
          }
          //数量核算
          if (datas.numberAccounting && datas.unit == "") {
            _.$message.error("请填写计量单位！");
            return false;
          }
          //外币核算
          if (datas.foreignCurrency && datas.foreignCurrencyStr <= 0) {
            _.$message.error("请选择外币类别！");
            return false;
          }

          datas.auxiliaryIds = "";
          if (datas.auxiliaryStrs && datas.auxiliaryStrs.length > 0) {
            let list = _.listLabel.fztypes;
            let lit = datas.auxiliaryStrs;
            for (let i = 0; i < lit.length; i++) {
              for (let k = 0; k < list.length; k++) {
                if (lit[i] == list[k].name) {
                  datas.auxiliaryIds += list[k].id + ",";
                }
              }
            }
          }
          datas.foreignCurrencyIds = "";
          if (datas.foreignCurrencyStr && datas.foreignCurrencyStr.length > 0) {
            let list = _.listLabel.wbtypes;
            let lit = datas.foreignCurrencyStr;
            for (let i = 0; i < lit.length; i++) {
              for (let k = 0; k < list.length; k++) {
                if (lit[i] == list[k].name) {
                  datas.foreignCurrencyIds += list[k].id + ",";
                }
              }
            }
          }
          datas.auxiliaryStr = datas.auxiliaryStrs.join(",");
          datas.foreignCurrencyStr = datas.foreignCurrencyStr.join(",");

          delete datas.auxiliaryStrs;
          // 修复补0
          // if(Number(datas.selfCode) < 10 && String(datas.selfCode).length < 2) {
          //   datas.selfCode = "0" + datas.selfCode;
          // }
          _.$http.post("subject/validate", datas).then((res) => {
            if (res.data.code == 92) {
              _.$confirm(
                "该科目已使用，新增下级，将把原科目余额移动至下级科目上，还要继续吗?",
                "提示",
                {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                }
              ).then(() => {
                _.seveSubjectList(datas); //提交科目
              });
            } else if (res.data.code == 0) {
              // this.$message.error(res.data.msg);
              // key = false
            } else {
              _.seveSubjectList(datas); //提交科目
            }
          });
          //   if (
          //     (_.subjectData.methods == "newAdd" ||
          //       _.subjectData.methods == "add") &&
          //     datas.fk_superSubject != "" &&
          //     !_.hasChild1 &&
          //     _.haveData1
          //   ) {
          //     _.$confirm(
          //       "上级科目已有凭证，保存后新增科目将替代凭证中的上级科目，您要继续吗?",
          //       "提示",
          //       {
          //         confirmButtonText: "确定",
          //         cancelButtonText: "取消",
          //         type: "warning",
          //       }
          //     ).then(() => {
          //       _.seveSubjectList(datas); //提交科目
          //     });
          //     return false;
          //   }
        }
      });
    },
    seveSubjectList(datas) {
      const _ = this;
      if (!_.ifmbf) {
        datas.attribute == "";
      }
      _.dialog.loading = true;
      _.loadingText = "保存科目中";
      _.$http
        .post("subject/saveSubject", datas)
        .then((res) => {
          _.dialog.loading = false;
          if (res && res.data.code == "1") {
            //新增 新增科目成功后的回调用于凭证新增成功的操作
            if (_.subjectData.methods == "add") {
              let objs = "";
              _.listLabel.parentObject.find((item) => {
                if (item.id == datas.fk_superSubject) {
                  objs = item;
                }
              });
              const dataObj = res.data.data.data;
              _.$emit("add-success-subject", {
                code: datas.code,
                id: dataObj.id,
                selfCode: datas.selfCode,
                subname: datas.subname,
                oldSubname: objs.name,
                newCode: dataObj ? dataObj.code : null
              });
            }
            _.$message({
              message: _.editTit + "成功!",
              type: "success",
            });
            let pushArr = res.data.data.data;
            pushArr.children = [];
            if (datas.id != "") {
              _.$emit("on-save-success", "edit");
            } else {
              _.$emit("on-save-success", pushArr);
            }
            _.dialog.modal = false;
            //_.getData();
          }
        })
        .catch(() => {
          _.dialog.loading = false;
        });
    },
    groupsChange(val, keys) {
      const _ = this;
      if (val.length <= 0) {
        this.formData[keys] = false;
      }
    },
    chagesCheck(val, key) {
      key == "unit" ? (this.formData[key] = "") : this.formData[key].splice(0);
    }, //新增科目
    addSubject(row) {
      const _ = this;
      _.disedit = false;

      _.hasChild = true;
      _.haveData = false;

      _.formData = _.$resert(_.formData);
      _.ifCashJournal = false;
      _.ifBankJournal = false;
      _.ifEdit = false;
      _.ifNewAdd1 = false;
      _.ifNewAdd2 = false;
      _.ifNewAdd3 = false;
      _.formData.type = row.type || "资产";
      _.formData.fk_superSubject = row.pid || "";
      _.formData.code = row.code || "";
      _.formData.creditDirection = row.creditDirection;
    }, //新增下一级
    addChildEditor(row) {
      const _ = this;
      _.hasChild = false;
      _.haveData = false;
      _.resert(row);
      _.formData.fk_superSubject = row.id;
      _.formData.subname = "";
      delete _.formData.id;
      _.ifEdit = false;
      _.disedit = false;
      _.disFK = true;
      //console.log(_.disEdit,_.disedit);
      // 新增下一级 如果 辅助核算  数量核算  外币核算 选择  就不能进行修改
      row.auxiliary ? (_.ifNewAdd1 = true) : (_.ifNewAdd1 = false);
      row.numberAccounting ? (_.ifNewAdd2 = true) : (_.ifNewAdd2 = false);
      row.foreignCurrency ? (_.ifNewAdd3 = true) : (_.ifNewAdd3 = false);
    }, //修改
    editorEditor(row) {
      const _ = this;
      _.resert(row);
      _.formData.id = row.id;
      //console.log(row)
      //delete _.formData.fk_superSubject;
      _.formData.subname = row.subname;
      _.ifNewAdd1 = false;
      _.ifNewAdd2 = false;
      _.ifNewAdd3 = false;
      //当时二级以上的科目时 如果存在下级 就只能修改 科目名称 和 记账
      row.level >= 2 && row.hasChild ? (_.ifEdit = true) : (_.ifEdit = false);
      _.formData.code = "";
      _.formData.selfCodeStr = "";
    },
    disEditAble(row, value) {
      const _ = this;
      if (value == "edit") {
        if (row.level == 1) {
          if (!row.hasChild && row.initialValue) {
            //没有下级 没有被使用
            _.ifSubName = true;
            _.haveData = false;
            _.hasChild = true;
            _.ifEdits = false;
          } else if (!row.initialValue && !row.hasChild) {
            //不能进行修改
            _.ifEdits = true;
          }
        } else {
          if (!row.hasChild && !row.initialValue) {
            //没有下级并且被使用 只能修改科目名称
            _.haveData = true;
            _.hasChild = true;
            _.ifSubName = false;
            _.ifCashJournal = true;
            _.ifBankJournal = true;
          } else if (!row.hasChild && row.initialValue) {
            //没有下级并且未使用
            _.haveData = false;
            _.hasChild = true;
            _.ifSubName = false;
            _.ifCashJournal = false;
            _.ifBankJournal = false;
          } else if (row.hasChild) {
            _.haveData = true;
            _.hasChild = true;
            _.ifSubName = false;
            _.ifCashJournal = true;
            _.ifBankJournal = true;
          }
        }
      } else if (value == "newAdd") {
        //新增下级二级和一级的都是一样的判断条件
        if (!row.hasChild && row.initialValue) {
          //未使用且没有下级
          _.ifSubName = false;
          _.hasChild = true;
          _.haveData = false;
          _.ifNewAdd1 = false;
          _.ifNewAdd2 = false;
          _.ifNewAdd3 = false;
        } else if (!row.initialValue && !row.hasChild) {
          //被使用且 没有下级
          _.ifSubName = false;
          _.hasChild = true;
          _.haveData = false;
          _.ifNewAdd1 = true;
          _.ifNewAdd2 = true;
          _.ifNewAdd3 = true;
        } else if (row.hasChild) {
          //存在下级
          _.ifSubName = false;
          _.hasChild = true;
          _.haveData = false;
          _.ifNewAdd1 = false;
          _.ifNewAdd2 = false;
          _.ifNewAdd3 = false;
        }
      }
    },
    resert(row) {
      const _ = this;
      //console.log('修改1',row)
      _.disFK = false;
      _.formData = _.$resert(_.formData, row);
      if (row.methods == "newAdd") {
        // _.getAllSubjectByTree(function () {

        // });
        _.disableChage(row.id, false, function () {
            _.disEditAble(row, "newAdd");
            //console.log('名称',_.ifSubName,'辅助1',_.ifNewAdd1,'辅助2',_.ifNewAdd2,'辅助3', _.ifNewAdd3 ,'修改',_.ifEdit ,'是否使用',_.haveData,'是否下级',  _.hasChild,'修改',_.ifEdit);
          });
      } else if (row.methods == "edit") {
        if (
          row.superSubjectId != "0" &&
          row.superSubjectId != "" &&
          row.superSubjectId != null
        ) {
          _.formData.fk_superSubject = row.superSubjectId;
          _.getAllSubjectByTree(function () {
            _.disableChage(row.superSubjectId, false, function () {
              _.disEditAble(row, "edit");
            });
          });
        } else {
          _.formData.code = "";
          _.formData.selfCode = row.code;
        }
        _.disEditAble(row, "edit");
      }
      if (row.auxiliary != null && row.auxiliary != undefined) {
        _.formData.auxiliaryStrs = row.auxiliary;
      }
      if (row.foreignCurrencys != null && row.foreignCurrencys != undefined) {
        _.formData.foreignCurrencyStr = row.foreignCurrencys;
      }
      ///辅助核算  如果辅助核算有值 则有辅助核算并赋值
      if (row.auxiliary && row.auxiliary.length > 0) {
        _.formData.auxiliary = true;
        _.formData.auxiliaryStrs = row.auxiliary;
      } else {
        _.formData.auxiliary = false;
        _.formData.auxiliaryStrs = [];
      }
    },
    cancel() {
      this.dialog.modal = false;
      this.$refs.formData.resetFields();
      this.$emit("on-close-modal", false);
    },
    handlerSubject(row) {
      ///处理对象传值
      const _ = this;
      if (row.methods == "add") {
        //新增科目
        _.addSubject(row);
      } else if (row.methods == "newAdd") {
        //新增下一级科目
        _.addChildEditor(row);
      } else if (row.methods == "edit") {
        //修改科目
        _.editorEditor(row);
      }
    },
  },
  created() {
    this.findAllOject();
    this.findAllCurrency();
    this.getAllSubjectType();
  },
  mounted() {
    this.dialog.modal = this.show;
    this.getAllSubjectByTree(()=> {
          this.handlerSubject(JSON.parse(JSON.stringify(this.subjectData)));
        })
  },
  watch: {
    show(val) {
      this.dialog.modal = this.show;
    },
    // subjectData: {
    //   handler(val) {
    //     this.handlerSubject(JSON.parse(JSON.stringify(val)));
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    "formData.type": {
      handler(val) {
        if (val == "收入") {
          this.checkIfPrivateNonProfit();
        }
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="less">
.form-item-public {
  .warining {
    display: block;
    text-align: center;
    color: red;
    margin-top: -20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/subjectDialog.vue